import { render, staticRenderFns } from "./customer-layout.vue?vue&type=template&id=b517fa00"
import script from "./customer-layout.vue?vue&type=script&lang=js"
export * from "./customer-layout.vue?vue&type=script&lang=js"
import style0 from "./customer-layout.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsUiWrapper: require('/home/node/app/components/elements/ui-wrapper/ui-wrapper.vue').default,ElementsUiIcon: require('/home/node/app/components/elements/ui-icon/ui-icon.vue').default,ElementsUiLink: require('/home/node/app/components/elements/ui-link/ui-link.vue').default,ElementsPageTitle: require('/home/node/app/components/elements/page-title/page-title.vue').default,PatternsCustomerTitle: require('/home/node/app/components/patterns/customer-title/customer-title.vue').default})
